import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { uploadImages, uploadVideo } from 'redux/modules/composebox';
import { addImage, removeImage, orgInitialState, updateImageOrder } from 'redux/modules/composeboxForm';
import { ImagePickerContainer } from 'containers';
import { Spinner, Tooltip } from 'components';
import * as styles from './Composebox.scss';

var Dropzone = require('react-dropzone');

var ImagePostSection = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    uploadingImage: state.composebox.uploadingImage,
    fileUploadError: state.composebox.fileUploadError
  };
}, {
  addImage: addImage,
  removeImage: removeImage,
  uploadImages: uploadImages,
  updateImageOrder: updateImageOrder
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ImagePostSection, _Component);

  var _super = _createSuper(ImagePostSection);

  function ImagePostSection(props) {
    var _this;

    _classCallCheck(this, ImagePostSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOver", function (ev) {
      ev.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (ev) {
      _this.setState({
        dragId: ev.currentTarget.id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrop", function (ev, imgObjs) {
      ev.preventDefault();
      var dragId = _this.state.dragId;
      var dragImage = imgObjs.find(function (image) {
        return image.id == dragId;
      });
      var dropImage = imgObjs.find(function (image) {
        return image.id == ev.currentTarget.id;
      });

      var newOrder = _this.moveItem(dragImage.id, dropImage.id, imgObjs);

      _this.setState({
        previewImages: newOrder
      });

      _this.props.updateImageOrder(newOrder, _this.props.organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleImages", function (images) {
      images.forEach(function (obj) {
        _this.props.addImage(obj.fullyQualifiedUrl, _this.props.organizationId);
      });
    });

    _this.state = {
      maxImageCount: 4,
      previewImages: _this.props.composeboxForm.images,
      dragId: ""
    };
    return _this;
  }

  _createClass(ImagePostSection, [{
    key: "moveItem",
    value: function moveItem(from, to, imgobjs) {
      imgobjs.map(function (el) {
        return el.url;
      });
      var previewImages = this.state.previewImages;
      var f = previewImages.splice(from, 1)[0];
      previewImages.splice(to, 0, f);
      return previewImages;
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var _this2 = this;

      var previewImages = this.state.previewImages;
      var imgObjs;

      if (previewImages.length) {
        imgObjs = previewImages.map(function (item, index) {
          item = {
            url: item,
            id: index
          };
          return item;
        });
        return /*#__PURE__*/React.createElement(Fragment, null, imgObjs.length && imgObjs.map(function (element, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: index,
            id: element.id,
            style: {
              position: 'relative'
            },
            draggable: true,
            onDragOver: function onDragOver(e) {
              return _this2.handleOver(e);
            },
            onDragStart: function onDragStart(e) {
              return _this2.handleDrag(e);
            },
            onDrop: function onDrop(e) {
              return _this2.handleDrop(e, imgObjs);
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.imageCloseBtn,
            onClick: function onClick() {
              return _this2.props.removeImage(index, _this2.props.organizationId);
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "icon ion-ios-close-empty ".concat(styles.imageCloseBtnIcon)
          })), /*#__PURE__*/React.createElement("div", {
            className: styles.uploadedImage,
            style: {
              backgroundImage: "url(".concat(element.url, ")")
            }
          }));
        }));
      }
    }
    /** *********************************************************
     RENDER
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var composeboxForm = this.props.composeboxForm;
      var previewImages = this.state.previewImages;
      var hasGif = composeboxForm && composeboxForm.images && !!composeboxForm.images.length && composeboxForm.images.find(function (i) {
        return i.indexOf('gif') !== -1;
      });
      var hasMaxImages = composeboxForm && composeboxForm.images && composeboxForm.images.length === this.state.maxImageCount;
      var numberOfImages = composeboxForm && composeboxForm.images ? composeboxForm.images.length : 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h4", {
        style: {
          color: '#8b8b8b'
        }
      }, composeboxForm && composeboxForm.images && composeboxForm.images.length > 1 && /*#__PURE__*/React.createElement(Tooltip, {
        message: "Multi-image posts may look different in the preview than social networks."
      }), composeboxForm && composeboxForm.images && hasGif && /*#__PURE__*/React.createElement(Tooltip, {
        message: "A post may only contain one GIF image."
      })), this.props.fileUploadError ? /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, this.props.fileUploadError) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          width: 545,
          minHeight: 125,
          position: 'relative'
        }
      }, this.renderPreview(), !hasMaxImages && !hasGif && !this.props.uploadingImage && /*#__PURE__*/React.createElement(ImagePickerContainer, {
        parentImageHandler: this.handleImages,
        buttonText: "Add Image",
        maxImageCount: this.state.maxImageCount - numberOfImages
      }), this.props.uploadingImage && /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.composeboxForm.images !== state.previewImages) {
        return {
          previewImages: props.composeboxForm.images
        };
      }

      return null;
    }
  }]);

  return ImagePostSection;
}(Component)) || _class);
export { ImagePostSection as default };